// @flow
export const DATE_TIME_INTERVAL = 'hive/hub/DATE_TIME_INTERVAL';
export const POLL_API_START = 'hive/hub/POLL_API_START';
export const POLL_API_STOP = 'hive/hub/POLL_API_STOP';
export const DEFAULT_TIMEZONE = 'Europe/London';
export const INTERVAL = 60000;
export const GET_PRODUCTS_INTERVAL = 50000;
export const NUMBER_OF_DAYS_DISPLAYED = 7;



// WEBPACK FOOTER //
// ./src/core/state/hub/constants.js